import {Component, Input} from '@angular/core';
import {UserResponse} from '../../../../@shared/models/response.module';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {EditUserProfile} from './components/edit-user-profile/edit-user-profile';
import {formatTimeYMD} from '../../../../@core/utils/utils.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-user-profile-overview',
  standalone: false,
  templateUrl: './user-profile-overview.html',
  styleUrl: './user-profile-overview.css'
})
export class UserProfileOverview {
  @Input() user: UserResponse

  constructor(private modal: NgbModal,
              private router: Router) {
  }

  openEditProfileModal() {
    let modalRef = this.modal.open(EditUserProfile, {size: 'lg', centered: true});
    modalRef.componentInstance.user = this.user;
    modalRef.result.then((result) => {
      if (result) {
        this.user = result;
        location.reload()

      }
    })
  }

  protected readonly formatTimeYMD = formatTimeYMD;
  protected readonly Date = Date;
}
